import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=27987768&scoped=true&"
import script from "./InputCurrency.vue?vue&type=script&lang=js&"
export * from "./InputCurrency.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/input-currency.scss?vue&type=style&index=0&id=27987768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27987768",
  null
  
)

export default component.exports